export enum GlobalStatusCodesEnum {
    Success = 1,
    Error = 100,
}
